import { abilities } from "../constants";
import SpotlightCard from "../blocks/Components/SpotlightCard/SpotlightCard";
import GlareHover from "../blocks/Animations/GlareHover/GlareHover";

const FeatureCards = () => (
  <section className="w-full lg:px-32 md:px-16 px-5 bg-black">
    <div className="text-center mb-16">
      <h2 className="text-white text-4xl font-bold">Mes Services</h2>
    </div>

    <div className="mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-16">
      {abilities.map(({ imgPath, title, desc }) => (
        <SpotlightCard
          key={title}
          className="custom-spotlight-card transform transition-all duration-500 hover:-translate-y-2 hover:shadow-blue-500/20 hover:shadow-lg"
          spotlightColor="rgba(0, 130, 255, 0.12)"
        >

            <div className="flex flex-col gap-5 items-center text-center">
              <div className="w-auto md:h-48 flex justify-center items-center">
                <img src={imgPath} alt={title} className="w-auto lg:h-48 md:h-32 h-24" />
              </div>
              <h3 className="text-white text-2xl font-bold">{title}</h3>
              <p className="text-white-50 text-base">{desc}</p>
            </div>

            <div className="flex justify-center mt-6">
              <a href="#contact" className="contact-btn group">
                <GlareHover
                  glareColor="#fff"
                  glareOpacity={0.3}
                  glareAngle={-30}
                  glareSize={300}
                  transitionDuration={800}
                  playOnce={false}
                >
                  <span className="px-8 py-3">Contactez-moi</span>
                </GlareHover>
              </a>
            </div>
        </SpotlightCard>
      ))}
    </div>
  </section>
);

export default FeatureCards;
